import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { USGenericRoutingModule } from './us-generic-routing.module';
import { USGenericComponent } from './us-generic.component';
import { AppComponent } from 'src/app/app.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HeaderWithMenuComponent } from 'src/app/components/header-with-menu/header-with-menu';
import { SharedModule } from 'src/app/shared/shared.module';
import { UpsellModule } from 'src/app/shared/upsell.module';


@NgModule({
  declarations: [
    USGenericComponent,
  ],
  imports: [
    USGenericRoutingModule,
    CommonModule,
    FormsModule,
    SharedModule,
    UpsellModule
  ],
  providers: [
    Storage,
    HeaderWithMenuComponent,
  ],
  exports: [
    USGenericComponent,
  ],
  bootstrap: [AppComponent,    HeaderWithMenuComponent,],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class USGenericModule { }





